// extracted by mini-css-extract-plugin
export var blue = "_1g-g";
export var brand = "_1g-c";
export var darkGrey = "_1g-f";
export var disabled = "_1g-6";
export var disabledSubtle = "_1g-7";
export var error = "_1g-8";
export var green = "_1g-h";
export var grey = "_1g-e";
export var icon = "_1g-0";
export var inherit = "_1g-b";
export var lightGrey = "_1g-d";
export var orange = "_1g-j";
export var pink = "_1g-l";
export var primary = "_1g-1";
export var purple = "_1g-m";
export var quaternary = "_1g-4";
export var quinary = "_1g-5";
export var red = "_1g-k";
export var secondary = "_1g-2";
export var success = "_1g-a";
export var tertiary = "_1g-3";
export var warning = "_1g-9";
export var white = "_1g-n";
export var yellow = "_1g-i";